import React from "react";

export const formGroup = {
  kodePart: { value: "", mandatory: true },
  partName: { value: "", mandatory: true },
  partCategory: { value: "", mandatory: true },
  qrCode: { value: null, mandatory: true },
  satuan: { value: "", mandatory: true },
  status: { value: "ACTIVE" },
};

export const tableConfig = [
  {
    name: "kodePart",
    label: "Kode Part",
    options: {
      sort: false,
    },
  },
  {
    name: "partName",
    label: "Nama Part",
    options: {
      sort: false,
    },
  },
  {
    name: "partCategory",
    label: "Kelompok Category",
    options: {
      customBodyRender: (val) => <p>{val}</p>,
      sort: false,
    },
  },
  {
    name: "satuan",
    label: "Satuan",
    options: {
      customBodyRender: (val) => <p>{val}</p>,
      sort: false,
    },
  },
];
